import { groupBy } from "lodash-es";

import type { ConstraintListItemDto } from "@/api/types";
import type { IconComponent } from "@/components/Icon/Icon";
import { Building01Icon } from "@/components/Icons/Building01Icon";
import { Home02Icon } from "@/components/Icons/Home02Icon";
import { LayersThree01Icon } from "@/components/Icons/LayersThree01Icon";

type AudienceType = ConstraintListItemDto["type"];

export const mapAudienceByType = (
  listAudience: ConstraintListItemDto[],
): Record<ConstraintListItemDto["type"], ConstraintListItemDto[]> => {
  return groupBy(listAudience, (audience) => audience.type) as Record<
    ConstraintListItemDto["type"],
    ConstraintListItemDto[]
  >;
};

export const flattenAudience = (
  audience: Record<ConstraintListItemDto["type"], ConstraintListItemDto[]>,
): ConstraintListItemDto[] => {
  return Object.values(audience).flat();
};

export const orderAudienceTypes = (audienceTypes: AudienceType[]): AudienceType[] => {
  const desiredAudienceTypeOrder: ConstraintListItemDto["type"][] = ["apartmentType", "building", "floor"];

  return audienceTypes.sort(
    (typeA, typeB) => desiredAudienceTypeOrder.indexOf(typeA) - desiredAudienceTypeOrder.indexOf(typeB),
  );
};

export const getIconByAudienceType = (type: AudienceType | undefined): IconComponent | undefined => {
  switch (type) {
    case "floor":
      return <LayersThree01Icon />;
    case "building":
      return <Building01Icon />;
    case "apartmentType":
      return <Home02Icon />;
    default:
      return undefined;
  }
};
